<script setup>
import { defineProps, ref, watch, nextTick, computed } from 'vue'
import Chart from 'chart.js/auto'

const props = defineProps({
  data: {
    type: Object,
    required: true
  }
})

const chartCanvas = ref(null)
let chartInstance = null

// Validamos que haya datos válidos
const hasValidData = computed(() => {
  return props.data &&
    typeof props.data.billable === 'number' &&
    typeof props.data.non_billable === 'number' &&
    (props.data.billable + props.data.non_billable) > 0
})

const renderChart = () => {
  if (!chartCanvas.value) return

  // Destruir instancia anterior si existe
  if (chartInstance) {
    chartInstance.destroy()
  }

  chartInstance = new Chart(chartCanvas.value, {
    type: 'pie',
    data: {
      labels: ['Facturable', 'No Facturable'],
      datasets: [{
        data: [props.data.billable, props.data.non_billable],
        backgroundColor: ['#4CAF50', '#FF5252']
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false
    }
  })
}

// Observamos los datos y esperamos a que el DOM esté listo
watch(
  () => props.data,
  async () => {
    if (hasValidData.value) {
      await nextTick()
      renderChart()
    }
  },
  { immediate: true, deep: true }
)
</script>

<template>
  <div v-if="hasValidData" class="d-flex flex-column align-items-center p-2" style="max-width: 100%;">
    <div style="width: 250px; height: 250px;">
      <canvas ref="chartCanvas" style="width: 100%; height: 100%;"></canvas>
    </div>
    <ul class="mt-3 small text-center list-unstyled">
      <li><strong>Total:</strong> {{ props.data.billable + props.data.non_billable }} h</li>
      <li><strong>Facturable:</strong> {{ props.data.billable }} h</li>
      <li><strong>No Facturable:</strong> {{ props.data.non_billable }} h</li>
    </ul>
  </div>
  <p v-else class="text-center text-muted">No hay datos suficientes para mostrar.</p>
</template>
